module.exports = __webpack_public_path__ + "img/rebuild_huang_pc3.d7ac5294.jpg";